import axios from "axios";
import { API_ADDRESS } from "../../constants/config";

export class PricesService {
  public fetchPrices = async (params) => {
    try {
      const { dateRange, limit, offset } = params;
      if (!dateRange[0]._isAMomentObject || !dateRange[1]._isAMomentObject)
        throw new Error("Date range not valid!");

      const { blockTo, blockFrom } = {
        blockFrom: dateRange[0].format("x"),
        blockTo: dateRange[1].format("x"),
      };
      const paramString = `from=${blockFrom}&to=${blockTo}&type=json&limit=100&offset=${
        offset ? offset : 0
      }`;
      const { data } = await axios.get(
        `${API_ADDRESS}/public/contract/blocks?${paramString}`
      );

      if (
        (blockFrom >= 1527775200000 && blockFrom <= 1588230000000) ||
        (blockTo >= 1588230000000 && blockTo <= 1588230000000)
      ) {
        const { default: historicalPrices } = await import(
          "./historicalPrices.json"
        );
        const historicalData = historicalPrices.filter(
          (item) => item.date >= blockFrom && item.date <= blockTo
        );
        return {
          data: historicalData.concat(data.data),
          page: 1,
          pageSize: 100,
          results: historicalData.concat(data.data).length,
        };
      }

      return data;
    } catch (e) {
      console.log(e);
      throw Error(e.message);
    }
  };
}
